var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLightBulb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 48,
    height: 50,
    viewBox: "0 0 48 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.138 23.033c0-5.959-3.99-10.07-9.95-10.07a9.8 9.8 0 0 0-10.19 10.19c0 5.236 5.874 10.79 5.874 14.985h8.392c0-2.997 5.874-9.478 5.874-15.105Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.063 39.816a1.678 1.678 0 0 1-1.678 1.678h-8.393a1.678 1.678 0 0 1 0-3.356h8.392a1.677 1.677 0 0 1 1.678 1.678Zm0 3.357a1.678 1.678 0 0 1-1.678 1.678h-8.393a1.679 1.679 0 0 1 0-3.357h8.392a1.68 1.68 0 0 1 1.678 1.68Z",
    fill: "#D1C8FE",
    stroke: "#531DAB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.384 44.851a4.2 4.2 0 0 1-8.392 0h8.392Z",
    fill: "#fff",
    stroke: "#531DAB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.138 23.033c0-5.959-3.99-10.07-9.95-10.07a9.8 9.8 0 0 0-10.19 10.19c0 5.236 5.874 10.79 5.874 14.985h8.392c0-2.997 5.874-9.478 5.874-15.105Z",
    stroke: "#531DAB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m23.23 38.138-3.736-11.2a1.91 1.91 0 0 1 3.164-1.956 1.992 1.992 0 0 0 2.82 0 1.911 1.911 0 0 1 3.16 1.953l-3.735 11.2",
    stroke: "#531DAB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m42.072 39.011 2.343 1.874m-1.377-11.501 2.999-.036m-3.03-13.027 2.876-.853M35.5 7.827l1.856-2.357m-12.69-.637v-3M13.491 8.719 12.15 6.036M5.961 17.01l-2.572-1.544M4.667 28.5h-3m8.01 10.406L7.334 40.78",
    stroke: "#531DAB",
    strokeLinecap: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLightBulb);
export default __webpack_public_path__ + "static/media/icon_light_bulb.d0e3774ae0d5d0c864bc6bd8d52287c0.svg";
export { ForwardRef as ReactComponent };